import { render, staticRenderFns } from "./note_add.vue?vue&type=template&id=46e600b9&"
import script from "./note_add.vue?vue&type=script&lang=ts&"
export * from "./note_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports